export default __webpack_public_path__ + "static/media/mercedes2.c3cfc1ca.jpeg";